<template>
	<div class="carousel-wrapper">
    <div id="carousel" class="carousel">
		  <slot></slot>
    </div>
	</div>
</template>

<script>
import {useMediaQuery} from "@vueuse/core";

const isSmallScreen = useMediaQuery('(max-width: 600px)');

export default {
	name: 'Carusel',
  computed: {
    isSmallScreen() {
      return isSmallScreen.value;
    }
  },
  methods: {
    scrollLeft() {
      const carousel = document.getElementById('carousel');
      const scrollAmount = -300;
      carousel.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    },
    scrollRight() {
      const carousel = document.getElementById('carousel');
      const scrollAmount = 300;
      carousel.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel {
	height: 200px;
	display: flex;
  padding: 20px;
	overflow-x: scroll; /* Enable horizontal scrolling */
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none;  /* For Internet Explorer and Edge */

  /* Hide scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  flex-direction: row;
	align-items: center;
}

.carousel > :not(:first-child) {
	margin-left: 30px;
}

.button-left, .button-right {
  cursor: pointer;
}

.button-left {
  margin-right: 10px;
  width: 0;
  height: 0;
  border-top: 60px solid transparent;
  border-bottom: 60px solid transparent;

  border-right: 60px solid rgba(0, 0, 0, 1);
}

.button-right {
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 60px solid transparent;
  border-bottom: 60px solid transparent;

  border-left: 60px solid rgba(0, 0, 0, 1);
}

@media (max-width: 600px) {
  .button-left, .button-right {
    visibility: hidden;
  }
}
</style>